/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services/hub.service';

interface Res {
  data: {
    data: any;
    [key: string]: any;
  };
}

interface Params {
  [key: string]: any;
}

export const marketplaceActions = {
  getAssets,
  addAsset,
  updateAsset,
  deleteAsset,
  getCategories,
  addCategory,
  deleteCategory,
};

function unwrap(promise: any, context: string): any {
  if (promise && 'data' in promise) return promise.data;
  console.log(`error in actions ${context}`);
  return Promise.reject(`Error: ${context}`);
}

function getAssets(): Promise<any> {
  return services
    .get<Res>(`/marketplace/list?limit=500`)
    .then((p) => unwrap(p, 'get assets'));
}

function addAsset(params: Params): Promise<any> {
  return services.post<Res>(`/marketplace/add`, params).then((p) => unwrap(p, 'add asset'));
}

function updateAsset(id: string | number, params: Params): Promise<any> {
  return services
    .put<Res>(`/marketplace/update/${id}`, params)
    .then((p) => unwrap(p, 'update asset'));
}

function deleteAsset(id: string | number): Promise<any> {
  return services
    .delete<Res>(`/marketplace/delete/${id}`)
    .then((p) => unwrap(p, 'delete asset'));
}

function getCategories(): Promise<any> {
  return services
    .get<Res>(`/marketplace/categories/list`)
    .then((p) => unwrap(p, 'get categories'));
}

function addCategory(params: Params): Promise<any> {
  return services
    .post<Res>(`/marketplace/categories/add`, params)
    .then((p) => unwrap(p, 'add category'));
}

function deleteCategory(id: string | number): Promise<any> {
  return services
    .delete<Res>(`/marketplace/categories/delete/${id}`)
    .then((p) => unwrap(p, 'delete category'));
}
